import React, {Button, Component, useState } from "react";

// components
import Cookies from 'universal-cookie';
import getLezioni from "../../services/getLezioni";
import getCorsi from "../../services/getCorsi";
import getGruppiInsegnanti from "../../services/getGruppiInsegnanti";
import getInsegnanti from "../../services/getInsegnanti";
import getChiusura from "../../services/getChiusura";
import Utils from "../../utils/utils";
import moment from 'moment';
import { Page, Text, View, Document, StyleSheet, Image  } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import getClient from "../../services/getClient";

export default class PdfDocentiPage extends React.Component {

  constructor(props){
    super (props)
    this.state = {
    };
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
    const dateFrom = cookies.get('dateFrom', { path: '/' });
    const dateTo = cookies.get('dateTo', { path: '/' });

    var dDateFrom = moment(dateFrom + " 00:00:00", "yyyy-MM-DD HH:mm:ss");
    var dDateTo = moment(dateTo + " 23:59:59", "yyyy-MM-DD HH:mm:ss");

    this.logoUrl = window.sessionStorage.getItem('logo');
    
    this.lezioni = await getLezioni(username, token);
    this.gruppiInsegnanti = await getGruppiInsegnanti(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.chiusura = await getChiusura(username, token);
    this.corsi = await getCorsi(username, token);

    this.gruppoInsegnante = this.gruppiInsegnanti.find(g => g.id == currentInsegnante);
    this.currentInsegnanti = this.gruppoInsegnante.insegnanti.split('---');

    this.lezioni = this.lezioni.filter(l => {
      var find = false;
      this.currentInsegnanti.forEach(i => {
        if (i == '') return;
        if (l.id_insegnante == i)
          find = true;
        let indexFound = l.altri_insegnanti.split(';').indexOf(i);
        if (indexFound != -1)
          find = true;
      });
      return find;

    });


    this.lezioni = this.lezioni.filter(l => {
      var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
      if (dateFrom != "" && ll < dDateFrom) return false;
      if (dateTo != "" && ll > dDateTo) return false;
      return true;
    });

    this.lezioni.sort((l1, l2) => {
      var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
      var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
      return data1 < data2 ? -1 : 1;
    })

    this.mesi = [];
    this.coppieMesi = [];
    var tempMese = '';

    this.lezioni.forEach(l => {
      var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
      var mmYYYY = moment(ll).format('yyyy-MM');
      if (this.mesi.indexOf(mmYYYY) == -1){
        this.mesi.push(mmYYYY);
        if (tempMese == ''){
          tempMese = mmYYYY;
        } else {
          this.coppieMesi.push([tempMese, mmYYYY]);
          tempMese = '';
        }
      }
    })

    if (tempMese != ''){
      var u = undefined;
      this.coppieMesi.push([tempMese]);
    }

    this.setState({});
  }

  render () {
    return (<div style={{width: '100%', height: '100%'}} key={Math.random()}> 
    <PDFViewer style={{width: '100%', height: '100%'}}>
    <Document>
    {
        this.coppieMesi && this.coppieMesi.map(coppiaMesi => {
        var mese1 = coppiaMesi[0];
        var mese2 = coppiaMesi[1];
        var strMese1 = '';
        var strMese2 = '';

        var ggMese1 = [];
        var ggMese2 = [];
        
        var ll1 = mese1 && moment(mese1, "yyyy-MM");
        var ll2 = mese2 && moment(mese2, "yyyy-MM");

        var dataToDisplay = [];

        if (mese1){
          strMese1 = Utils.capitalizeFirstLetter(moment(mese1, "yyyy-MM").format('MMMM YYYY'));
          var d = ll1.clone();
          d.day = 1;
          while (d.month() == ll1.month()){
            ggMese1.push(moment(d).format("DD"))
            d = d.add(1, 'days');
          }

          dataToDisplay.push({
            strMese: strMese1,
            mese: mese1,
            ll: ll1.clone(),
            ggMese: ggMese1,
          });
        }

        if (mese2){
          strMese2 = Utils.capitalizeFirstLetter(moment(mese2, "yyyy-MM").format('MMMM YYYY'));

          var d = ll2.clone();
          d.set('date', 1);
          while (d.month() == ll2.month()){
            ggMese2.push(moment(d).format("DD"))
            d = d.add(1, 'days');
          }

          dataToDisplay.push({
            strMese: strMese2,
            mese: mese2,
            ll: ll2.clone(),
            ggMese: ggMese2,
          });
        }

        let timeNow = moment().format('yyyy-MM-DD HH:mm:ss');

        return (<Page size="A4" orientation="landscape" wrap >
        <Image style={{position: 'absolute', top: 10, left: 10, width: '10%', height: 'auto'}} src={this.logoUrl ? this.logoUrl : require('../../images/icon.png')} />
        <Text style={{position: 'absolute', top: 10, right: 10, fontSize: 12, width: '100%', textAlign: 'right'}}>{timeNow}</Text>
        <Text style={{margin: 10, fontSize: 25, width: '100%', textAlign: 'center'}}>{this.gruppoInsegnante.nome}</Text>
        <View style={styles.page} >
        {
          dataToDisplay.map(currentData => {
            return (<View style={{flexDirection: 'column', width: '50%'}}>
            <Text style={{marginBottom: '10px', fontSize: 12, fontWeight: 'bold'}}>{currentData.strMese}</Text>
            {
  
            currentData.ggMese.map(gg => {
  
              var d = currentData.ll.clone();
              d.set('date', parseInt(gg));
              var weekEnd = false;
              if (d.isoWeekday() == 7 || d.isoWeekday() == 6) weekEnd = true;
              var strNumberAndDay = gg + ' ' + d.format('dddd').substr(0,1).toUpperCase();
  
              var lezioniGiorno = this.lezioni.filter(l => {
                var lM = moment(l.data, "yyyy-MM-DD HH:mm:ss").format("yyyy-MM");
                var lD = moment(l.data, "yyyy-MM-DD HH:mm:ss").format("DD");
                return currentData.mese == lM && gg == lD;
              });
  
              var flagChiusura = false;
              this.chiusura.forEach(c => {
                var chiusura = moment(c.day, "DD-MM-yyyy HH:mm:ss").format('yyyy-MM-DD');
                var strTemp = moment(d).format('yyyy-MM-DD');
                if (chiusura == strTemp) flagChiusura = true;
              });

              return (
                <View style={styles.row} wrap={false}>
                  <Text style={{flexDirection: 'column', padding: 1, width: '7%'}}>{strNumberAndDay}</Text>
                  <View style={(weekEnd && lezioniGiorno.length != 0) ? styles.weekEndOrangeDay : (weekEnd || flagChiusura) ? styles.weekEndDay : styles.weekDay}>
                    {
                      flagChiusura ? 
                      <Text>CHIUSURA SCUOLA</Text> 
                      :
                      lezioniGiorno.map(l => {

                        var strAltriCorsi = '';
                        l.altri_corsi.split(';').forEach(i => {
                            if (i == '') return;
                            var corso = this.corsi.find(temp => temp.id == i);
                            if (corso == undefined) return;
                            strAltriCorsi += ' - ' + corso.name;
                        });
                        
                        var strAltriInsegnanti = '';
                        var arrAltriInsegnanti = l.altri_insegnanti.split(';');
                        arrAltriInsegnanti.forEach((i, index) => {
                            if (i == '') return;
                            var insegnante = this.insegnanti.find(temp => temp.id == i);
                            if (insegnante == undefined) return;
                            if (strAltriInsegnanti == '') 
                              strAltriInsegnanti += " con " + l.nome_ins + ' ' + l.cognome_ins + ', ';
                            else if (index == arrAltriInsegnanti.length - 2)
                              strAltriInsegnanti += " e ";
                            else 
                              strAltriInsegnanti += ", ";

                            strAltriInsegnanti += insegnante.nome + ' ' + insegnante.cognome;
                        });

                        if (strAltriInsegnanti == '')
                        strAltriInsegnanti = ', ' + l.nome_ins + ' ' + l.cognome_ins;

                        var orario = moment(l.data, "yyyy-MM-DD HH:mm:ss").format("HH:mm");
                        var orarioFine = moment(l.data, "yyyy-MM-DD HH:mm:ss").add(l.durata, 'minutes').format("HH:mm");
    
                        //return (<Text>{orario + ' - ' + orarioFine + ' ' + l.str_corso + ' - ' + l.nome_ins + ' ' + l.cognome_ins + ' ' + l.str_materia}</Text>);

                        return (<Text>{orario + ' - ' + orarioFine + ' ' + l.str_corso + strAltriCorsi + ' ' + l.str_materia + strAltriInsegnanti} </Text>);

                      })
                    }
                </View>
              </View>

              );
            })
          }
          </View>);
        })
      }
      </View>
      </Page>)
       })
      }
    
  </Document>
  </PDFViewer></div>);
  }

}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    border:'1 solid #000',
    width: '90%',

  },
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
    fontSize: 8,
    backgroundColor: '#ffffff',
    paddingLeft: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  weekEndOrangeDay: {
    borderLeft:'1 solid #000',
    flexDirection: 'column', 
    padding: 2, 
    width: '93%',
    backgroundColor: '#ffad18'
  },
  weekEndDay: {
    borderLeft:'1 solid #000',
    flexDirection: 'column', 
    padding: 2, 
    width: '93%',
    backgroundColor: '#ff0000'
  },
  weekDay: {
    borderLeft:'1 solid #000',
    flexDirection: 'column', 
    padding: 2, 
    width: '93%',
  },
});
